/**
 * Yarn Blog Section (Stories Grid + Mobile Slider Controller)
 * Upload to: assets/yarn-blog-section.js
 */

(function () {
  'use strict';

  function initBlogSection(container) {
    if (!container || container.dataset.yblInitialized) return;
    container.dataset.yblInitialized = 'true';

    // Intersection Observer for scroll reveal
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              container.classList.add('is-inview');
              observer.unobserve(container);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(container);
    } else {
      container.classList.add('is-inview');
    }

    // Mobile Slider Dots Sync
    const slider = container.querySelector('[data-ybl-slider]');
    const dots = container.querySelectorAll('[data-ybl-dot]');

    if (slider && dots.length > 0) {
      let isScrolling;

      slider.addEventListener(
        'scroll',
        function () {
          window.clearTimeout(isScrolling);
          isScrolling = setTimeout(function () {
            const scrollLeft = slider.scrollLeft;
            const cardWidth = slider.querySelector('.ybl-card')?.offsetWidth || 300;
            const activeIndex = Math.round(scrollLeft / (cardWidth + 16));

            dots.forEach((dot, idx) => {
              dot.classList.toggle('is-active', idx === activeIndex);
            });
          }, 60);
        },
        { passive: true }
      );

      // Dot click to scroll
      dots.forEach((dot) => {
        dot.addEventListener('click', function () {
          const index = parseInt(dot.dataset.yblDot, 10);
          const cards = slider.querySelectorAll('.ybl-card');
          if (cards[index]) {
            cards[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          }
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-yarn-blog-section]').forEach(initBlogSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor Integration
  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('[data-yarn-blog-section]');
    if (section) initBlogSection(section);
  });
})();
